import { createContext, useContext } from 'react';

export const SpellcheckContext = createContext({ enabled: true });

export function useSpellcheckEnabled() {
    return useContext(SpellcheckContext).enabled;
}
